import React from 'react'
import { string, func } from 'prop-types'
import LazyLoad from 'react-lazy-load'
import { ExpressBox, StyledLink, WrapFlex } from './styles'

import { WebPBackgroundImage } from '@pcln/content-tile'

const Container = ({
  linkTagAnalytics,
  linkTagAction,
  linkTagLabel,
  image,
  imageWebP,
  clickAction
}) => (
  <StyledLink
    linkTagAnalytics={linkTagAnalytics}
    linkTagAction={linkTagAction}
    linkTagLabel={linkTagLabel}
    onClick={clickAction}
  >
    <WrapFlex width='375px' justifyContent='center'>
      <ExpressBox width={300}>
        <LazyLoad once height={333} debounce={false} throttle={50}>
          <WebPBackgroundImage
            image={image}
            imageWebP={imageWebP}
            height='333px'
            style={{
              backgroundColor: 'transparent',
              backgroundSize: '100% 100%'
            }}
          />
        </LazyLoad>
      </ExpressBox>
    </WrapFlex>
  </StyledLink>
)

Container.displayName = 'Container'

Container.propTypes = {
  image: string,
  imageWebP: string,
  linkTagAnalytics: string,
  linkTagAction: string,
  linkTagLabel: string,
  clickAction: func
}

export default Container
